import React from 'react';
import BaseSelect from 'react-select';
import './select.scss';
import classNames from 'classnames';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const DropDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" className={'svg-icon'}>
    <path fillRule="evenodd" fill="#AFBAD2" d="M10.45.5L5.5 5.449.55.5" />
  </svg>
);

interface ISelectProps {
  options: object;
  value: string;
  onChange: (Event) => null;
  outerTop: boolean;
  className: string;
  disabled: boolean;
  inputDisabled: boolean
}

const Select = ({
  options, value, onChange, outerTop, className, disabled, inputDisabled
}: ISelectProps): JSX.Element => (
  <BaseSelect
    onChange={onChange}
    options={options}
    className={classNames('select-container', {
      // 'outer-top': outerTop,
      disabled,
    }, className)}
    menuPlacement={outerTop ? 'top': 'bottom'}
    classNamePrefix="select"
    onMenuOpen={() => {
      disableBodyScroll(document.querySelector('.select-container'))
    }}
    onMenuClose={() => {
      clearAllBodyScrollLocks();
    }}
    defaultValue={value}
    isSearchable={!inputDisabled}
    isDisabled={disabled}
    value={value}
    components={{
      IndicatorsContainer: DropDown,
    }}
  />
);

export default Select;
